import React, { useState, useEffect, useRef } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { connect } from "react-redux";
import styles from "./NewProject.module.scss";
import { useHistory } from "react-router-dom";
import Lottie from "react-lottie";
import successData from "../../assets/lotties/27-loading.json";
import {
  setProyectoNuevoPaso1,
  deleteProyecto,
  openMainModal,
  closeMainModal,
  resetSubProjects,
  resetIdProject,
  updateProyecto,
  clearPostulationProject,
  getProjectQuestions,
  setEditProjectsShow,
  setProjectFormStyle,
  closeEdifySpinner,
  getProjectsByType,
  setSubProjectStyle,
  resetProjectToEdit,
  getPrivateProjectById,
} from "../../store/actions";
import { ReactComponent as Pencil } from "../../assets/svg/pencil-new.svg";
import { ReactComponent as Cancel } from "../../assets/svg/cancel.svg";
import { ReactComponent as Publicar } from "../../assets/svg/publicarProyecto.svg";
import { ReactComponent as Rubros } from "../../assets/svg/rubrosACotizar.svg";
import { ReactComponent as CloseIcon } from "../../assets/svg/xClose.svg";
import useFileUpload from "../../hooks/useFileUpload";
import DetailsForm from "../UI/DetailsForm/DetailsForm";
import Subproyectos from "../Proyectos/Subproyectos/Subproyectos";
import { motion } from "framer-motion";
import { fireAnalytics } from "../../utils/firebase";
import SpinnerEdify from "../UI/Loading/SpinnerEdify";
const variants = {
  visible: {
    scale: 1.0,
  },
  hidden: {
    scale: 1.1,
  },
};
const defaultOptions = {
  loop: true,
  autoplay: true,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const ProyectoSchema = Yup.object().shape({
  name: Yup.string().required("El campo es requerido"),
  description: Yup.string().required("El campo es requerido"),
  endDate: Yup.date().required("El campo es requerido"),
  zone: Yup.string().required("El campo es requerido"),
});

const NewProject = ({
  userData,
  sendSubprojects,
  clearPostulationProject,
  setProyectoNuevoPaso1,
  openMainModal,
  closeMainModal,
  resetSubProjects,
  resetIdProject,
  isEditing,
  postulationProject,
  updateProyecto,
  getProjectQuestions,
  deleteProyecto,
  handleClose,
  getPrivateProjectById,
  closeModal,
  step1Project,
  setEditProjectsShow,
  formStep2Style,
  setProjectFormStyle,
  edifySpinner,
  subProjectsToEdit,
  closeEdifySpinner,
  getProjectsByType,
  setSubProjectStyle,
  resetProjectToEdit,
  ...props
}) => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const history = useHistory();
  const [zone, setZone] = useState(isEditing ? postulationProject.zone : "");
  const [image, setImage] = useState(isEditing ? postulationProject.proyecto_images[0]?.image : "");
  const [changedZone, setChangeZone] = useState(false);
  const [step1Checker, setStep1Checker] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isButtonStep1Active, setIsButtonStep1Active] = useState(false);
  const [isUpdateButtonActive, setIsUpdateButtonActive] = useState(false);
  const [hidenForm, setHidenForm] = useState(false);
  const [finalStep, setFinalStep] = useState(false);
  const [imageEdit, setImageEdit] = useState([]);
  const [changedImages, setChangedImages] = useState(false);
  const [finishAndPublish, setFinishAndPublish] = useState(false);
  const [imageFile, imageChangeHandler, fileName] = useFileUpload(
    image,
    setImage
  );

  let imageFileEdit = []

  let today = new Date();
  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0");
  let yyyy = today.getFullYear();
  let startDate = yyyy + "-" + mm + "-" + dd;



  const initialValues = {
    name: isEditing ? postulationProject.name : "",
    description: isEditing ? postulationProject.description : "",
    endDate: isEditing ? postulationProject.endDate : "",
    zone: isEditing ? postulationProject.zone : "",
    image: isEditing ? postulationProject.proyecto_images[0]?.image : "",
  };
  const formik = useFormik({
    initialValues,
    validationSchema: ProyectoSchema,
    enableReinitialize: true,
  });

  //Maneja el estado del boton de Finalizar y publicar
  useEffect(() => {
    if (subProjectsToEdit.subproyecto?.length === 0 || subProjectsToEdit?.length === 0 || subProjectsToEdit.subproyecto?.length === undefined) {
      setFinishAndPublish(false);
    } else {
      setFinishAndPublish(true);
    }
  }, [subProjectsToEdit.subproyecto, subProjectsToEdit]);

  //Maneja el estado de boton paso 1 
  useEffect(() => {
    if (
      formik.values.name !== "" &&
      formik.values.description !== "" &&
      formik.values.endDate !== "" &&
      formik.values.zone !== "") {
      setIsButtonStep1Active(true);
    } else {
      setIsButtonStep1Active(false);
    }
  }, [formik.values]);

  //Definimos ruta a redirigir usuario 
  const userFullName = userData.type === "COMPANY" ? userData.razon_social : userData.name + " " + userData.last_name;
  const userRoute = `/comunidad-edify/${userData.id}/${userFullName}`;


  //Array de imagenes existentes en el proyecto
  const imagesFromProject = postulationProject.proyecto_images;

  // Array del Proyecto en etapa de creación paso 1
  const lastProjectId = step1Project.id;

  // Maneja el texto del botón de publicar proyecto paso 1
  let contentPaso = step1Checker ? "Completá los datos" : "Paso 1 de 2";

  useEffect(() => {
    resetProjectToEdit();
    closeEdifySpinner();
    resetSubProjects();
    resetIdProject();
    setSubProjectStyle(false);
    setProjectFormStyle(false);
    if (!isEditing) clearPostulationProject();
    return () => {
      resetSubProjects();
      resetIdProject();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Maneja el cambio en el botón Paso 1 de 2
  useEffect(() => {
    const formValues = Object.values(formik.values);
    const isFormValid = formValues.every(val => val === "");
    if (isFormValid && !isFormSubmitted) {
      setStep1Checker(true);
    } else {
      setStep1Checker(false);
    }
  }, [formik.values, isFormSubmitted]);


  useEffect(() => {

    const { name, description, endDate, zone } = formik.values;

    let isNameChanged = name !== initialValues.name;
    let isDescriptionChanged = description !== initialValues.description;
    let isEndDateChanged = endDate !== initialValues.endDate;
    let isZoneChanged = zone !== initialValues.zone;
    let isImageChanged = imageFile !== initialValues.image;
    if (isEditing && isNameChanged) {
      setIsUpdateButtonActive(true);
    }
    if (isEditing && isDescriptionChanged) {
      setIsUpdateButtonActive(true);
    }
    if (isEditing && isEndDateChanged) {
      setIsUpdateButtonActive(true);
    }
    if (isEditing && isZoneChanged) {
      setIsUpdateButtonActive(true);
    }
    if (isEditing && isImageChanged) {
      setIsUpdateButtonActive(true);
    }
    if (isEditing && changedImages) {
      setIsUpdateButtonActive(true);
    }
  }, [formik.values, isEditing, initialValues.name, initialValues.description, initialValues.endDate, initialValues.zone, imageFile, initialValues.image, changedImages]);

  // Función para crear el proyecto en el paso 1 de 2

  const divToScrollRef = useRef(null);

  const submitHandlerPaso1 = () => {
    const divToScroll = divToScrollRef.current;
    if (isEditing) {
      fireAnalytics("save_project", { category: "publishing" });
      updateProject();
    } else {
      fireAnalytics("publishing_create_project", { category: "navigation" });
      sendNewProjectStep1();
      setHidenForm(true);
      setProjectFormStyle(true);
      if (divToScroll) {
        divToScroll.scrollTop = 0;
      }
    }
  };

  const sendNewProjectStep1 = () => {

    const newProject = {
      ...formik.values,
      image: imageEdit,
      startDate: startDate,
    };
    if (
      formik.values.description !== "" &&
      formik.values.endDate !== "" &&
      formik.values.name !== "" &&
      formik.values.zone !== ""
    ) {
      fireAnalytics("publish_project", { category: "publishing" });
      openMainModal({
        title: "¡Completaste el Paso 1!",
        body: "Próximo Paso: Agregar al menos 1 rubro, y publicar el proyecto.",
        isSuccess: true,
        noActionNeeded: true,
        disableBackdropClick: true,
      },
        setTimeout(() => {
          setProyectoNuevoPaso1(newProject, history, closeModal);
          setStep1Checker(true);
          setIsFormSubmitted(true);
          setIsButtonStep1Active(false);
          closeMainModal();
          setHidenForm(false);
        }, 3000)
      );
    } else {
      openMainModal({
        title: "¡Atención!",
        body:
          formik.values.description === "" ||
            formik.values.endDate === "" ||
            formik.values.name === ""
            ? "Debes completar el paso 1. Adjuntar un nombre, imagen, descripción y fecha de finalización al proyecto para poder crearlo"
            : formik.values.zone === ""
              ? "Debes seleccionar una ubicación valida"
              : "Debes completar el paso 1. Adjuntar un nombre, imagen, descripción y fecha de finalización al proyecto para poder crearlo",
        isSuccess: true,
        confirmHandler: null,
        customCloseMainModal: () => {
          setStep1Checker(false);
          setIsFormSubmitted(false);
          setIsButtonStep1Active(true);
          closeMainModal();
          setHidenForm(false);
          setProjectFormStyle(false);
        },
      });
    }
  };

  // Cambia estado de visibilidad del formulario
  useEffect(() => {
    if (isFormSubmitted) {
      setHidenForm(true);
    }
  }, [isFormSubmitted]);

  // Nos devuelve a el momento de editar el paso 1 de 2

  const handleEditStep1 = (isEditing) => {
    const route = isEditing === true ? userRoute : "/dashboard";
    history.push(route);
  };

  //Botón de Finalizar y publicar proyecto
  const publishProject = () => {
    setFinalStep(true);
    setIsFormSubmitted(false);
    openMainModal({
      title: "¡Felicitaciones!",
      body: "Tu proyecto ha sido publicado con éxito.",
      isSuccess: true,
      confirmHandler: null,
      noLabel: "Gracias",
    });
    setProjectFormStyle(false);
    setEditProjectsShow(false);
    setTimeout(() => {
      if (isEditing) {
        history.push(userRoute);
      } else {
        getPrivateProjectById(step1Project.id);
        closeModal();
        history.push(`/proyectosprivados/${step1Project.id}`);
      }
    }, 2000);
  };

  // Botón de eliminar proyecto 
  const deleteHandler = () => {
    setHidenForm(true);
    const projectId = postulationProject.id || lastProjectId;
    fireAnalytics("draft_project", { category: "publishing" });
    openMainModal({
      title: "¿Deseas eliminar el proyecto?",
      body: "Si elimina el proyecto, nadie podra postularse.",
      isSuccess: false,
      confirmHandler: () => {
        deleteProyecto(projectId);
        handleEditStep1(isEditing);
      },
      customCloseMainModal: () => {
        setHidenForm(false);
        closeMainModal();
      },
    });
    setEditProjectsShow(false);
    setProjectFormStyle(false);
    closeModal && (closeModal());
  };

  // Función para editar el proyecto en el paso 2 de 2

  const updateProject = () => {
    const updateProject = {
      ...formik.values,
      startDate: postulationProject.startDate,
      link: postulationProject.link,
      zone: formik.values.zone,
    };
    let imageToSend = imageEdit
    if (
      formik.values.description === "" &&
      formik.values.endDate === "" &&
      formik.values.name === "" &&
      formik.values.zone === ""
    ) {
      openMainModal({
        title: "¡Atención!",
        body:
          formik.values.description === "" &&
            formik.values.endDate === "" &&
            formik.values.name === ""
            ? "Los campos de nombre, descripción y fecha de finalización no pueden estar vacíos"
            : zone === postulationProject.zone && changedZone
              ? "Debes seleccionar una ubicación diferente a la actual"
              : "Lamentablemente no hemos podido procesar su solicitud de actualización ya que no se han detectado cambios en el proyecto",
        isSuccess: true,
        confirmHandler: null,
      });
    } else {
      openMainModal({
        title: "¿Deseas guardar los cambios efectuados?",
        body: "Si tenías usuarios postulados en el proyecto, se le notificarán de los cambios realizados. ",
        isSuccess: false,
        confirmHandler: () => {
          updateProyecto(updateProject, imageToSend, postulationProject.id);
          setEditProjectsShow(false);
        },
      });
    }
  };

  //Setea la imagen a enviar
  const handleImageFilesChange = (file) => {
    setImageEdit(file);
  };

  return (
    <>
      {isEditing ? (
        <motion.div
          className={styles.newProjectEdit}
          initial="hidden"
          animate="visible"
          variants={variants}
          sizeTransition
        >

          <header className={styles.newProject_header}>
            <div className={styles.newProject_header_txtContainer}>
              <Pencil  width={15} height={15}/>
              <div>Editor de proyecto</div>
            </div>
            <div className={styles.close} onClick={() => {closeModal()}}>
              <span className={styles.cancel}>
                <CloseIcon  width={15} height={15} />
              </span>
            </div>
          </header>
          <main className={styles.newProject_container}>
            {!isFormSubmitted ? (
              <div className={styles.newProject_containerEdit}>
                <section className={styles.newProject_containerSection}>
                  <DetailsForm
                    setChangeZone={setChangeZone}
                    values={formik.values}
                    imageFile={imageFile}
                    imageChangeHandler={imageChangeHandler}
                    onImageFilesChange={handleImageFilesChange}
                    imageFileEdit={imageFileEdit}
                    formik={formik}
                    fileName={fileName}
                    fromNew
                    zone={zone}
                    setZone={setZone}
                    minDate={startDate}
                    isEditing={isEditing}
                    imagesFromProject={imagesFromProject}
                    hidenForm={hidenForm}
                    projectId={postulationProject.id}
                    setChangedImages={setChangedImages}
                  />
                </section>
              </div>) : null}
            {edifySpinner ? <SpinnerEdify /> : null}
            {isFormSubmitted || isEditing ? <section className={styles.newProject_containerSection}>
              <h4>
                <span className={styles.rubrosIcon}>
                  <Rubros />
                </span>
                Seleccionar rubros a cotizar
              </h4>
              <Subproyectos
                subprojectsEdit={postulationProject.subproyecto}
                isEditing={isEditing}
                projectIdForSub={postulationProject.id}
                closeModal={closeModal}
              />
            </section> : null}
            <div className={styles.newProject_buttonContainer}>
              {isEditing || isFormSubmitted ? (
                <button
                  className={`${styles.newProject_buttonDelete_button} ${styles.delete}`}
                  onClick={deleteHandler}
                >
                  Eliminar proyecto
                </button>
              ) : null}
              {isUpdateButtonActive && isEditing ? <div
                className={styles.newProject_button}
                onClick={updateProject}
                disabled={submitLoading}
              >
                {step1Checker ? (
                  <Lottie
                    options={{
                      animationData: successData,
                      ...defaultOptions,
                    }}
                    className={styles.lottie}
                    height={35}
                    width={35}
                  />
                ) : (
                  <div className={styles.contentStyle}>
                    <Publicar /> Guardar cambios
                  </div>
                )}
              </div> : null}
            </div>
          </main>
        </motion.div>) : (
        <motion.div
          className={hidenForm ? styles.newProject_hiden : styles.newProject}
          initial="hidden"
          animate="visible"
          variants={variants}
          sizeTransition
          style={isEditing ? { marginTop: "2rem" } : null}
        >
          {edifySpinner ? <SpinnerEdify /> : null}
          {finalStep ? null : (
            <div className={styles.bodyContainer}>
              <header className={formStep2Style && !hidenForm ? styles.newProject_hiden : styles.newProject_header}>
                <div className={styles.newProject_header_txtContainer}>
                  <Pencil width={15} height={15}/>
                  <div>Crear proyecto</div>
                </div>
                <div className={styles.close} onClick={() => {closeModal()}}>
                  <span className={styles.cancel}>
                    <CloseIcon width={15} height={15}/>
                  </span>
                </div>
              </header>
              <main ref={divToScrollRef} className={formStep2Style && !hidenForm ? styles.newProject_hiden : styles.newProject_container}>
                {!isFormSubmitted ? (
                  <div className={styles.newProject_fromNewContainer}>
                    <section className={styles.newProject_containerSection}>
                      <DetailsForm
                        setChangeZone={setChangeZone}
                        values={formik.values}
                        imageFile={imageFile}
                        imageChangeHandler={imageChangeHandler}
                        formik={formik}
                        fileName={fileName}
                        fromNew
                        zone={zone}
                        setZone={setZone}
                        minDate={startDate}
                        onImageFilesChange={handleImageFilesChange}
                        imageFileEdit={imageFileEdit}
                        hidenForm={hidenForm}
                        projectId={postulationProject.id}
                        setChangedImages={setChangedImages}
                      />
                    </section>
                    {!isEditing && (
                    <div
                      className={`${styles.newProject_button} ${isButtonStep1Active ? "" : styles.notShown}`}
                      onClick={submitHandlerPaso1}>
                      <div className={styles.contentStyle}>
                        <Publicar /> {contentPaso}
                      </div>
                    </div>)}
                  </div>) : null}
                {isFormSubmitted || isEditing ?
                  <section className={hidenForm ? styles.newProject_containerSection_hiden : styles.newProject_containerSection}>
                    <h4>
                      <span className={styles.rubrosIcon}>
                        <Rubros />
                      </span>
                      Seleccionar rubros a cotizar
                    </h4>
                    <Subproyectos
                      subprojectsEdit={postulationProject.subproyecto}
                      isEditing={isEditing}
                      projectIdForSub={step1Project.id}
                      closeModal={closeModal}
                      
                    />
                  </section> : null}
                <div className={`${styles.newProject_buttonContainer} ${isButtonStep1Active && !isFormSubmitted ?  styles.notShown : ""}`}>
                  {isFormSubmitted && finishAndPublish ? (
                  <div
                    className={styles.newProject_button}
                    onClick={publishProject}>
                    <div className={styles.contentStyle}>
                      <Publicar />
                      <p>Finalizar y publicar proyecto</p>
                    </div>
                  </div>) : null}
                  <div className={styles.newProject_buttonDelete}>
                    {isEditing || isFormSubmitted ? (
                      <button
                        className={styles.newProject_buttonDelete_button}
                        onClick={deleteHandler}
                      >
                        Eliminar proyecto
                      </button>
                    ) : null}
                    {isUpdateButtonActive && isEditing ? <div
                      className={styles.newProject_button}
                      onClick={updateProject}
                      disabled={submitLoading}
                    >
                      {step1Checker ? (
                        <Lottie
                          options={{
                            animationData: successData,
                            ...defaultOptions,
                          }}
                          className={styles.lottie}
                          height={35}
                          width={35}
                        />

                      ) : (
                        <div className={styles.contentStyle}>
                          <Publicar /> Guardar cambios
                        </div>
                      )}
                    </div> : null}
                  </div>
                </div>
              </main>
            </div>
          )}
        </motion.div>
      )}
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    userData: state.general.userData,
    showSubprojects: state.profile.showSubprojects,
    sendProject: state.profile.sendProject,
    projectIdForSub: state.profile.projectIdForSub,
    sendSubprojects: state.profile.sendSubprojects || state.profile.projectStep1Id.sendSubprojects,
    postulationProject: ownProps.postulationProject || state.dashboard.postulationProject,
    step1Project: state.profile.projectStep1Id,
    submitLoading: state.profile.submitLoading,
    formStep2Style: state.profile.styleForm,
    edifySpinner: state.general.edifySpinner,
    subProjectsToEdit: state.profile.projectToEdit
  };
};

export default connect(mapStateToProps, {
  setProyectoNuevoPaso1,
  setEditProjectsShow,
  setProjectFormStyle,
  setSubProjectStyle,
  resetSubProjects,
  resetIdProject,
  closeMainModal,
  closeEdifySpinner,
  openMainModal,
  updateProyecto,
  clearPostulationProject,
  deleteProyecto,
  getProjectQuestions,
  getProjectsByType,
  resetProjectToEdit,
  getPrivateProjectById,
})(NewProject);
